export default "__VITE_ASSET__mQC7Zm8U__"